module.exports = __webpack_public_path__ + "static/media/badge_ESP_Appstore.0ef91de8.png";